import { AddFundRequest, AddNewPortfolioRequest } from './types';
import Utils from '@/utils/Utils';

export const FundRequestPayload = (addFundRequest: AddFundRequest) => {
  return { ...addFundRequest };
};

export const PortfolioRequestPayload = (
  addPortfolioRequest: AddNewPortfolioRequest
) => {
  return { ...addPortfolioRequest };
};
